import {
    defineStore,
} from 'pinia';
import {
    computed, reactive, toRefs,
} from 'vue';
import {
    createAward,
} from '../models/Award';

export const DEFAULT_AWARD = {
    date: null,
    id: null,
    name: '',
    submitted: false,
    url: '',
};
const emptyAwardFactory = () => ({ ...JSON.parse(JSON.stringify(DEFAULT_AWARD)) });

export const useAwardStore = defineStore('profile-awards', () => {
    const newAward = reactive(emptyAwardFactory());
    const state = reactive({
        awards: [],
    });

    function clearNewRows() {
        const emptyAward = emptyAwardFactory();
        Object.keys(newAward).forEach((key) => {
            newAward[key] = emptyAward[key];
        });
    }

    function deleteAward(id) {
        state.awards = state.awards.filter(x => x.id !== id);
    }

    function updateFromQuery(data) {
        clearNewRows();
        // The default row is merged to make sure all necessary fields are initialized.
        state.awards = [
            ...data.map(award => ({
                ...DEFAULT_AWARD,
                date: award.date,
                id: award.id,
                name: award.name,
                url: award.url,
            })),
        ];
    }

    const count = computed(() => state.awards.length);
    const filled = computed(() => state.awards.length > 0);
    const models = computed(() => [...state.awards, newAward]
        .filter(x => x.id || x.submitted).map(x => createAward(x)));

    return {
        ...toRefs(state),
        newAward,
        models,
        count,
        filled,
        clearNewRows,
        deleteAward,
        delete: deleteAward,
        updateFromQuery,
    };
});
